export default __webpack_public_path__ + "static/media/i013hp.853acbd6.webp";